<template>
    <div>
        <v-search v-if="action !== 'rizhi'">
            <router-link v-if="show" :to="{path:'add'}"  class="f-right">
                <a-button type="primary" class="fr opbuttonmt">新增</a-button>
            </router-link>条件筛选
        </v-search>
        <v-tablelist></v-tablelist>
    </div>
</template>

<script>
import TableList from "./tablelist.vue";
import Search from "./search.vue";

export default {
    data() {
        return {
            show: true,
            action: ""
        };
    },
    methods: {},
    computed: {},
    components: {
        "v-tablelist": TableList,
        "v-search": Search
    },
    beforeMount() {
        const { path } = this.$route;
        this.action = path.split("/").pop();
        if (this.$route.path.indexOf("/jibie") > -1) {
            this.show = false;
        }
    },
    mounted() {}
};
</script>

<style scoped>
</style>